import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { spacing, typography, colors } from "../../../../../../assets/styles/tokens";

const KpiCardSkeleton = () => (
    <Box
        sx={{
            p: 2,
            border: `1px solid ${colors.GrayLightMode[200].$value}`,
            borderRadius: spacing.Radius.lg.$value,
            mb: 1.5,
        }}
    >
        <Stack direction="row" justifyContent="space-between" mb={1}>
            <Skeleton variant="text" width={80} height={24} />
            <Skeleton variant="text" width={40} height={24} />
        </Stack>
        <Stack direction="row" alignItems="baseline" spacing={1} mb={1}>
            <Skeleton variant="text" width={100} height={32} />
            <Skeleton variant="text" width={80} height={20} />
        </Stack>
        <Skeleton variant="rounded" height={6} sx={{ mb: 1.5, borderRadius: 2 }} />
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton variant="text" width="60%" height={20} />
        </Stack>
    </Box>
);

const SectionSkeleton = ({ title }: { title: string }) => (
    <Box sx={{ mb: 2 }}>
        <Typography
            variant="body1"
            sx={{
                fontWeight: typography.Font_weight.Medium.$value,
                color: colors.GrayLightMode[900].$value,
                mb: 1.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
            }}
        >
            {title}
        </Typography>
        <Stack spacing={0}>
            <KpiCardSkeleton />
            <KpiCardSkeleton />
        </Stack>
    </Box>
);

const KpiSkeleton = () => {
    return (
        <Box sx={{ py: 2 }}>
            <SectionSkeleton title="High Level KPI’s" />
            <SectionSkeleton title="Acquisition" />
            <SectionSkeleton title="Revenue Streams" />
            <SectionSkeleton title="Efficiency Metrics" />
            <SectionSkeleton title="Player Value" />
        </Box>
    );
};

export default KpiSkeleton;
